import { __asyncGenerator, __asyncValues, __await } from "tslib";
import { AsyncIterableX } from '../asynciterablex.mjs';
import { returnAsyncIterator } from '../../util/returniterator.mjs';
import { wrapWithAbort } from './withabort.mjs';
import { throwIfAborted } from '../../aborterror.mjs';
/** @ignore */
export class CatchWithAsyncIterable extends AsyncIterableX {
    constructor(source, handler) {
        super();
        this._source = source;
        this._handler = handler;
    }
    [Symbol.asyncIterator](signal) {
        return __asyncGenerator(this, arguments, function* _a() {
            var _b, e_1, _c, _d;
            throwIfAborted(signal);
            let err;
            let hasError = false;
            const source = wrapWithAbort(this._source, signal);
            const it = source[Symbol.asyncIterator]();
            while (1) {
                let c = {};
                try {
                    c = yield __await(it.next());
                    if (c.done) {
                        yield __await(returnAsyncIterator(it));
                        break;
                    }
                }
                catch (e) {
                    err = yield __await(this._handler(e, signal));
                    hasError = true;
                    yield __await(returnAsyncIterator(it));
                    break;
                }
                yield yield __await(c.value);
            }
            if (hasError) {
                try {
                    for (var _e = true, _f = __asyncValues(wrapWithAbort(err, signal)), _g; _g = yield __await(_f.next()), _b = _g.done, !_b; _e = true) {
                        _d = _g.value;
                        _e = false;
                        const item = _d;
                        yield yield __await(item);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (!_e && !_b && (_c = _f.return)) yield __await(_c.call(_f));
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        });
    }
}
/**
 * Continues an async-iterable sequence that is terminated by an exception with the
 * async-iterable sequence produced by the handler.
 *
 * @template TSource The type of the elements in the source sequence.
 * @template TResult The type of elements from the handler function.
 * @param {((
 *     error: any,
 *     signal?: AbortSignal
 *   ) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>)} handler Error handler function, producing another async-iterable sequence.
 * @returns {(OperatorAsyncFunction<TSource, TSource | TResult>)} An operator which continues an async-iterable sequence that is terminated by
 * an exception with the specified handler.
 */
export function catchError(handler) {
    return function catchWithOperatorFunction(source) {
        return new CatchWithAsyncIterable(source, handler);
    };
}

//# sourceMappingURL=catcherror.mjs.map
